/*jshint esversion: 6 */

import React from 'react';
import CaSlideGallery from './../general/CaSlideGallery';

const CaProfileCompletedQuizzesView = (props)=> {
    const { completedQuizzes,itemCaption, header, body } = props;

    const items = completedQuizzes.map((item,index)=>(
        <div key={index} className={"ProfileCompletedQuizzes__item SlideGallery__item"} >
            <div className={"ProfileCompletedQuizzes__backgroundImage SlideGallery__backgroundImage"} style={{backgroundImage:("url("+item.image+")")}} >
                <div className={"ProfileCompletedQuizzes__scoreOverlay"}>
                    <div className={"ProfileCompletedQuizzes__scoreOverlayInner"}>
                        { item.maxPoints > 0 && <div className={"ProfileCompletedQuizzes__scoreOverlayCaption"}>{itemCaption}</div> }
                        { item.maxPoints > 0 && <div className={"ProfileCompletedQuizzes__scoreOverlayScore"}>{item.points}/{item.maxPoints}</div> }
                    </div>
                </div>
            </div>
            <div className={"ProfileCompletedQuizzes__caption"}>{item.title}</div>
        </div>
    ));

    return(
        <div className={"ProfileCompletedQuizzes ProfilePageBlock"}>
            <div className={"ProfileCompletedQuizzes__content"}>
                <CaSlideGallery items={items} title={header} body={body} noHover={true} classNamePrepend={"ProfileCompletedQuizzes"} />
            </div>
        </div>
    )
};

export default CaProfileCompletedQuizzesView;




